import { useState } from 'react'
import { offerwallapi } from '../config/axiosconfig'
import { analytics } from '../utils/analytics'

export const useOfferActivation = ({
  offer,
  client,
  tenant,
  card,
  language,
  setActivated,
  isUnlimitedReactivation,
  setUnlimitedOfferActivated,
  isSingleActivation,
  setSingleOfferActivated,
  startCountdown,
}) => {
  const [loader, setLoader] = useState(false)
  const [message, setMessage] = useState('')

  const activateOffer = async () => {
    if (!client?.isenrolled) {
      return false
    }

    try {
      setLoader(true)

      const activationResponse = await offerwallapi.post(
        '/api/offers/offerpostattribution',
        {
          offerid: offer.id,
          action: 'ENROLL',
          tenantid: tenant?.tenantid,
          clientid: client?.clientid,
        }
      )

      // Handle activation states based on offer type
      if (isUnlimitedReactivation) {
        setActivated(true)
        setUnlimitedOfferActivated(true)
      }
      if (isSingleActivation) {
        setActivated(true)
        setSingleOfferActivated(true)
      }

      const analyticsdata = {
        ac: 'Activate Offer',
        ui: client ? client.externaluserid : '',
        oi: offer?.id,
        ti: tenant?.tenantid,
        tn: tenant?.tenantname,
      }

      analytics(analyticsdata, 'action-conversion')

      // Handle time-bound activation if enabled
      if (tenant?.tenantmasterconfig?.time_bound.enabled) {
        try {
          const attributesResponse = await offerwallapi.get(
            '/api/offers/offergetattributes',
            {
              params: {
                offerid: offer.id,
                tenantid: tenant.tenantid,
                clientid: client?.clientid,
                cardId:
                  card?.find((crd) => crd.isdefault === 1)?.cardnumber || null,
              },
            }
          )

          if (
            attributesResponse.data.attributions.length > 0 &&
            attributesResponse.data.attributions[0]?.expire
          ) {
            // Start countdown with expiry from attributes
            startCountdown(attributesResponse.data.attributions[0]?.expire)
            setActivated(true)

            // If there's a gap time configuration, start reactivation countdown
            if (tenant?.tenantmasterconfig?.time_bound.activation_gap > 0) {
              startCountdown(
                attributesResponse.data.attributions[0]?.expire,
                true
              )
            }
          }
        } catch (attrError) {
          console.error('Error fetching offer attributes:', attrError)
        }
      }

      setMessage(language?.success_res.success_l8)
      return true
    } catch (err) {
      console.error('Activation error:', err)
      setMessage(language?.error_res.error_l8)
      return false
    } finally {
      setLoader(false)
    }
  }

  return {
    loader,
    message,
    activateOffer,
    setLoader,
  }
}
